export default __webpack_public_path__ + "static/media/Blooded Boots of the Everlasting Sky.062ca48b.jpg";